export default __webpack_public_path__ + "static/media/incompability-icon.f71d9f2d.svg";